export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/?signup=core',

  // Authenticated routes
  PROFILE: '/profile',
  PROMPTS: '/prompts',
  BUILD: '/build/contract',
  CONTRACTS: '/contracts',
  ADMIN: '/admin',

  // Settings is now a tab within Profile page
  SETTINGS: '/profile?tab=settings',
};

// Route labels for navigation
export const ROUTE_LABELS = {
  [ROUTES.HOME]: 'Home',
  [ROUTES.LOGIN]: 'Login',
  [ROUTES.PROFILE]: 'Profile',
  [ROUTES.PROMPTS]: 'Prompts',
  [ROUTES.BUILD]: 'Build',
  [ROUTES.CONTRACTS]: 'Contracts',
  [ROUTES.ADMIN]: 'Admin',
  [ROUTES.SETTINGS]: 'Settings',
};

// Session storage keys
export const SESSION_KEYS = {
  // Authentication
  AUTH_TOKEN: 'auth_token',

  // Notifications
  VOLUME: 'gigacore.notificationVolume',
  MUTED: 'gigacore.notificationMuted',
};
